<template>
  <svg
    width="38px"
    height="32px"
    viewBox="0 0 38 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <g id="Symbols" stroke="none" stroke-width="1" fill-rule="evenodd">
      <g
        id="10-Teaser-/-Icon-/-nobadge"
        transform="translate(-10.000000, -18.000000)"
      >
        <path
          id="Chatbubble"
          d="M42.7870161,18 C45.2722974,18 47.2870161,20.0147186 47.2870161,22.5 L47.2870161,45.6110514 L47.3519671,49.5 L39.7354526,45.6917427 L14.9875798,45.6234373 C12.5071569,45.6165912 10.5,43.6038868 10.5,41.1234545 L10.5,22.5 C10.5,20.0147186 12.5147186,18 15,18 L42.7870161,18 Z M19.0396423,29.7817959 C17.1467242,29.7817959 15.6122108,31.3163093 15.6122108,33.2092275 C15.6122108,35.1021456 17.1467242,36.636659 19.0396423,36.636659 C20.9325605,36.636659 22.4670739,35.1021456 22.4670739,33.2092275 C22.4670739,31.3163093 20.9325605,29.7817959 19.0396423,29.7817959 Z M29.2552925,29.7817959 C27.3623743,29.7817959 25.8278609,31.3163093 25.8278609,33.2092275 C25.8278609,35.1021456 27.3623743,36.636659 29.2552925,36.636659 C31.1482106,36.636659 32.682724,35.1021456 32.682724,33.2092275 C32.682724,31.3163093 31.1482106,29.7817959 29.2552925,29.7817959 Z M39.4709426,29.7817959 C37.5780244,29.7817959 36.043511,31.3163093 36.043511,33.2092275 C36.043511,35.1021456 37.5780244,36.636659 39.4709426,36.636659 C41.3638608,36.636659 42.8983741,35.1021456 42.8983741,33.2092275 C42.8983741,31.3163093 41.3638608,29.7817959 39.4709426,29.7817959 Z"
        ></path>
      </g>
    </g>
  </svg>
</template>
